import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DeleteModal = ({ show, handleHide, title, text, confirmDelete }) => {
  const { t: translator } = useTranslation();
  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{translator(title)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{translator(text)}</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          {translator("Users-DeleteModal-Cancel")}
        </button>
        <button
          onClick={confirmDelete}
          type="button"
          className="btn btn-primary"
        >
          {translator("Users-DeleteModal-Confirm")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
